import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const institutionCodesApi = {
    getInstitutionCodes: (): Observable<Dtos.GetInstitutionCodesResponse> => {
        //Create the request.
        let request: Dtos.GetInstitutionCodes = new Dtos.GetInstitutionCodes();

        //Send request.
        const response: Promise<Dtos.GetInstitutionCodesResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getInstitutionCodeById: (id: number): Observable<Dtos.GetInstitutionCodeByIdResponse> => {
        //Create the request.
        let request: Dtos.GetInstitutionCodeById = new Dtos.GetInstitutionCodeById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetInstitutionCodeByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getInstitutionCodeByInstitutionId: (institutionId: number): Observable<Dtos.GetInstitutionCodesByInstitutionIdResponse> => {
        //Create the request.
        let request: Dtos.GetInstitutionCodesByInstitutionId = new Dtos.GetInstitutionCodesByInstitutionId();

        request.institutionId = institutionId;

        //Send request.
        const response: Promise<Dtos.GetInstitutionCodesByInstitutionIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setInstitutionCode: (institutionCode: Dtos.InstitutionCode): Observable<Dtos.SetInstitutionCodeResponse> => {

        let request: Dtos.SetInstitutionCode = new Dtos.SetInstitutionCode();

        request.institutionCode = institutionCode;

        // send request
        const response: Promise<Dtos.SetInstitutionCodeResponse> = client.post(request);

        return Observable.from(response);

    },
    createInstitutionCode: (institutionId: number): Observable<Dtos.CreateInstitutionCodeResponse> => {
        //Create the request.
        let request: Dtos.CreateInstitutionCode = new Dtos.CreateInstitutionCode();

        request.institutionId = institutionId;

        //Send request.
        const response: Promise<Dtos.CreateInstitutionCodeResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateInstitutionCode: (institutionCode: Dtos.InstitutionCode): Observable<Dtos.ValidateInstitutionCodeResponse> => {

        let request: Dtos.ValidateInstitutionCode = new Dtos.ValidateInstitutionCode();

        request.institutionCode = institutionCode;

        // send request
        const response: Promise<Dtos.ValidateInstitutionCodeResponse> = client.post(request);

        return Observable.from(response);

    },
}